// Gender Options
const gender = [
  { value: 'M', label: 'männlich' },
  { value: 'F', label: 'weiblich' },
  { value: 'D', label: 'divers' },
];

export default gender;
